import {EmailReportTemplateEnum} from "./email-report-template.enum";
import {SiteFiltersType} from "../../commons/types/site-filters.type";

export const EmailReportTemplateFilterEnum = {
  [EmailReportTemplateEnum.DailyGroupsWorkloadReport]: SiteFiltersType.branchIds,
  [EmailReportTemplateEnum.DailyBranchesWorkloadReport]: SiteFiltersType.branchIds,
  [EmailReportTemplateEnum.DailyAgentWorkloadReport]: SiteFiltersType.branchIds,
  [EmailReportTemplateEnum.InactiveAgentReport]: SiteFiltersType.branchIds,
  [EmailReportTemplateEnum.TeamsAgentWorkloadReport]: SiteFiltersType.teamIds,
  [EmailReportTemplateEnum.TeamsWorkloadReport]: SiteFiltersType.teamIds,
  [EmailReportTemplateEnum.RoutePlanningStatus]: SiteFiltersType.branchIds
}
